$(document).ready(function () {
  const select2Selector = 'select.pg__option__value[aria-label="Size"]';
  $(select2Selector).select2({
    placeholder: "Selecciona una opción",
    minimumResultsForSearch: Infinity,
  }); 

  $(".nuclear_icon a").on("click",function(e) {
    // e.preventDefault();
    $('body').addClass('nuclear');
  })

  document.querySelectorAll('div[data-product-handle="jones-soda-x-crayola-limited-edition-12-pack"] .money').forEach(el => {
    const text = el.textContent.trim().replace(/\s+/g, '');
    const match = text.match(/^(\D*\d+)\.(\d{2})$/);

    if (match) {
      const [_, integerPart, decimalPart] = match;
      el.innerHTML = `${integerPart}.<span class="money-decimals">${decimalPart}</span>`;
    }
  });

  document.querySelectorAll('div[data-product-handle="jones-soda-x-crayola-limited-edition-6-pack"] .money').forEach(el => {
    const text = el.textContent.trim().replace(/\s+/g, '');
    const match = text.match(/^(\D*\d+)\.(\d{2})$/);

    if (match) {
      const [_, integerPart, decimalPart] = match;
      el.innerHTML = `${integerPart}.<span class="money-decimals">${decimalPart}</span>`;
    }
  });

});


var elem = document.querySelector('.sticker');
if(elem){ 
  window.addEventListener('scroll', function() {
   const sy = window.scrollY || document.documentElement.scrollTop;
    if(sy>200){
    elem.style.transform = `rotate(${sy}deg)`; 
    }
  });
}
let background = document.querySelector(".map-background");
if(background){
  document.addEventListener("scroll", function () {
      let scrollPosition = window.scrollY;
      background.style.backgroundPositionX = scrollPosition * 0.5 + "px";
  });
}
// New Logic for 6x6-you-choose-mixed-case
let PRODUCT_DATA = null;

const productEl = document.querySelector('.product-single-json');

if (productEl) {
  const handle = productEl.dataset.handle;

  if (handle === '6x6-you-choose-mixed-case') {

    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(data => {
        PRODUCT_DATA = data;
        console.log("✅ Product data loaded for:", handle);
      });

  }
}
document.addEventListener('click', function(e) {

  const productEl = document.querySelector('.product-single-json');
  const handle = productEl?.dataset.handle;

  if (handle !== '6x6-you-choose-mixed-case') return;

  const swatch = e.target.closest('.pg__option__value');
  if (!swatch) return;

  requestAnimationFrame(() => {

    const flavor1 = document.querySelector('.pg__option[data-index="0"] .selected')?.dataset.value;
    const flavor2 = document.querySelector('.pg__option[data-index="1"] .selected')?.dataset.value;

    if (!flavor1 || !flavor2) return;

    // 🔥 IMPORTANT CHECK
    if (!PRODUCT_DATA || !PRODUCT_DATA.variants) {
      console.warn("Product data not ready yet");
      return;
    }

    const variant = PRODUCT_DATA.variants.find(v =>
      v.option1 === flavor1 && v.option2 === flavor2
    );

    if (variant) {
      const input = document.querySelector('form[action="/cart/add"] [name="id"]');
      if (input && input.value != variant.id) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        console.log("⚡ Variant synced:", variant.id);
      }
    }

  });

});